import { DELETE_INGREDIENTS_FROM_GROCERY_WAITLIST } from "./actionTypes";

export default (payload) => ({
  type: DELETE_INGREDIENTS_FROM_GROCERY_WAITLIST,
  payload,
});
